import { coerceToNonEmpty } from '../../typeguards';
import { isCompleteCommerceItem } from './commerceDataTypes.js';
export function isLegacyInfoblockMvnFormat(subject) {
    const data = coerceToNonEmpty(subject);
    if (typeof data !== 'object' || data === null) {
        return false;
    }
    if (isCompleteCommerceItem(data.formatted)) {
        return true;
    }
    return isEasyAzonFormat(data.retrievedData ?? false);
}
function isEasyAzonFormat(subject) {
    const data = coerceToNonEmpty(subject);
    if (typeof data !== 'object' || data === null) {
        return false;
    }
    return ('title' in data &&
        typeof data.title === 'string' &&
        'identifier' in data &&
        typeof data.identifier === 'string' &&
        'images' in data &&
        Array.isArray(data.images) &&
        'offer' in data &&
        typeof data.offer === 'object' &&
        'locale' in data &&
        typeof data.locale === 'string');
}
//# sourceMappingURL=legacy.js.map